import utils from '../../services/utils'

export default {
  props: ['data', 'quickShop', 'borders', 'event_id', 'shouldRefetchOnFavorite'],

  data() {
    return {
      trackingInfo: {
        'Brand name': this.data.brand_name
      },
      EXHIBITOR: 'EXHIBITOR',
      APPLICATION: 'APPLICATION'
    }
  },

  methods: {
    openQuickShopModal,
    urlFormatter: utils.urlSafeString,
    replaceImage() {
      if (this.data && !this.data.thumbnail_image_url) {
        const num = this.data.id.toString().match(/\d+/)[0][0]
        return new URL(
          `../../assets/img/nyn-images-event-id-1909/Cloud-${num === 0 || num > 6 ? '3' : num}.jpg`,
          import.meta.url
        ).href
      }
    }
  },
  computed: {
    boothID() {
      const { event_booths, booth } = this.data
      if (event_booths) return event_booths[this.event_id]
      return booth
    },
    canShowNyNowBoothNumber() {
      return !!this.boothID
    },
    canShowThumbnailBadge() {
      return !!this.data?.event_ids?.includes(this.event_id)
    }
  }
}

function openQuickShopModal(product) {
  if (this.$session.getAccessToken()) {
    this.$eventBus.$emit('show-quick-shop-modal', product)
  } else {
    this.$eventBus.$emit('show-quick-shop-modal-unregistered', product)
    this.$eventBus.$emit('apply-modal-unregistered', product)
  }
}
